<!-- TODO: PDF Viewer Toolbar for edit new template / mapping should go here -->

<!-- Main loading indicator if the template isn't fully ready -->
@if (!isTemplateViewReady) {
  <div class="loading-bar-wrapper">
    <app-progress-bar></app-progress-bar>
    <p>{{ loadingViewMessage }}</p>
  </div>
}

<as-split #splitEl>
  <!-- PDF viewer (left side) slider/resize container -->
  <as-split-area [size]="50" [maxSize]="65" [minSize]="35">
    <div class="PDF-main-container">
      <app-extended-pdf-viewer
        #pdfViewer
        (pdfLoadedAndProxyEmitter)="parseNewTemplatePdfDocumentProxy($event)"
        >
      </app-extended-pdf-viewer>
    </div>
  </as-split-area>
  <!-- New Template properties and Input Grid (right side) slider/resize container -->
  <as-split-area [size]="50">
    <div class="pdf-edit-right-panel">
      @if (isTemplateViewReady) {
        <app-edit-template-form-table-host
          [isTemplateViewReady]="isTemplateViewReady"
        ></app-edit-template-form-table-host>
      }
    </div>
  </as-split-area>
</as-split>
